import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import picking from './picking.png';
import { Rolling } from 'components/Rolling';
import { useStocksQuery } from 'components/Stock/Stock.hooks';
import { Link } from 'react-router-dom';
import { useMemo } from 'react';
import { shuffle } from 'routes/Util/Util.helper';
import { usePageTitle } from 'routes/Util/Util.hooks';
const Josa = require('josa-js');

export const HomePage = () => {
  const { data: stocks } = useStocksQuery('us');
  const rollingElements = useMemo(
    () => shuffle(stocks.map(stock => `${stock.krShortName}${Josa.c(stock.krShortName,'이/가')} 고점 대비 ${stock.declineRate.toFixed(1)}% 하락했습니다.`)),
    [stocks]);

  usePageTitle('시작');

  return (
    <div className="home-page h-100 mx-auto d-flex justify-content-center align-items-center">
      <Container className="container py-5 text-center">
        <Row>
          <Col>
            <Image width="200" height="200" src={picking} />
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="fs-3 mb-0">
              <span className="fw-bolder">줍줍</span> 할 주식 종목을 찾아보세요.
            </p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Link className="btn btn-secondary btn-lg" to="/US">시작하기</Link>
          </Col>
        </Row>
        <Row>
          <Col>
            <Rolling className="text-center mt-3" elements={rollingElements} />
          </Col>
        </Row>
      </Container>
    </div>
  )
}
